import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToFixConditionTypeComponent } from './condition-type.component';
import { FormsModule } from '@angular/forms';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@NgModule({
  declarations: [
    ToFixConditionTypeComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PipesModule
  ], exports: [
    ToFixConditionTypeComponent
  ]
})
export class ToFixConditionTypeModule { }
